import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

type Activity = any

const initialState = {
	activity: [] as Activity[],
	total: -1
}

type State = typeof initialState

const activitySlice = createSlice({
	initialState,
	name: 'activity',
	reducers: {
		allActivities: (state, action: PayloadAction<State>) => {
			state.activity = action.payload.activity
			state.total = action.payload.total
		},

		resetState() {
			return initialState
		}
	}
})

const { allActivities, resetState } = activitySlice.actions
export { activitySlice, allActivities, resetState }
